import { Record as ImmutableRecord, List } from 'immutable';
class TimezoneGroup extends ImmutableRecord({
  groupName: '',
  timezones: List()
}) {
  timezoneForMomentTimezone(timezone) {
    return this.timezones.find(tz => tz.momentTimezones.includes(timezone));
  }
}
export default TimezoneGroup;